export const noAccessPage = {
  NoAccessTitle: `Access is temporarily restricted`,
  NoAccessDescriptionStart: `The new Role Library experience is in Beta with limited user access. Go to `,
  NoAccessDescriptionEnd: ` on HRWeb to view roles at Microsoft.`,
  roleLibraryLink: 'Role Library',
};
